import { http } from './config'

export default {

  getAllProducts: () => {
    return http.get('products')
  },

  getFilteredProducts: (params) => {
    return http.get('products', { params })
  },

  getProductById: (product_id) => {
    return http.get('products/' + product_id)
  },

  getProductByIdIntegration: (codIntegration) => {
    return http.get('products/by_integration_id/' + codIntegration)
  },

  getProductByName: (name) => {
    return http.get('products/by_product_name/' + name)
  },

  createProduct: (productsParams) => {
    let formData = new FormData();
    formData.append('product[name]', productsParams.name);
    formData.append('product[package_id]', productsParams.package_id.id);

    if (productsParams.product_line_id.id != undefined) {
      formData.append('product[product_line_id]', productsParams.product_line_id.id);
    }

    if (productsParams.product_family_id.id != undefined) {
      formData.append('product[product_family_id]', productsParams.product_family_id.id);
    }

    if (productsParams.product_group_id.id != undefined) {
      formData.append('product[product_group_id]', productsParams.product_group_id.id);
    }

    if (productsParams.fragility_id.id != undefined) {
      formData.append('product[fragility_id]', productsParams.fragility_id.id);
    }

    if (productsParams.product_type_id.id != undefined) {
      formData.append('product[product_type_id]', productsParams.product_type_id.id);
    }

    formData.append('product[ean]', productsParams.ean);
    formData.append('product[integration_id]', productsParams.integration_id);
    formData.append('product[address]', productsParams.address);

    if (productsParams.image_params.name != undefined) {
      formData.append('product[image]', productsParams.image_params);
      formData.append('product[picture]', productsParams.image_params);
      formData.append('product[crop_x]', productsParams.coordinates.left);
      formData.append('product[crop_y]', productsParams.coordinates.top);
      formData.append('product[crop_w]', productsParams.coordinates.width);
      formData.append('product[crop_h]', productsParams.coordinates.height);
    }

    return http.post('products', formData)
  },

  updateProduct: (productsParams) => {
    let formData = new FormData();
    formData.append('product[name]', productsParams.name);

    if (productsParams.package_id.id != undefined) {
      formData.append('product[package_id]', productsParams.package_id.id);
    }

    if (productsParams.product_line_id.id != undefined) {
      formData.append('product[product_line_id]', productsParams.product_line_id.id);
    }

    if (productsParams.product_family_id.id != undefined) {
      formData.append('product[product_family_id]', productsParams.product_family_id.id);
    }

    if (productsParams.product_group_id.id != undefined) {
      formData.append('product[product_group_id]', productsParams.product_group_id.id);
    }

    if (productsParams.fragility_id.id != undefined) {
      formData.append('product[fragility_id]', productsParams.fragility_id.id);
    }

    if (productsParams.product_type_id.id != undefined) {
      formData.append('product[product_type_id]', productsParams.product_type_id.id);
    }

    formData.append('product[ean]', productsParams.ean);
    formData.append('product[integration_id]', productsParams.integration_id);
    formData.append('product[address]', productsParams.address);

    if (productsParams.image_params.name != undefined) {
      formData.append('product[image]', productsParams.image_params);
      formData.append('product[picture]', productsParams.image_params);
      formData.append('product[crop_x]', productsParams.coordinates.left);
      formData.append('product[crop_y]', productsParams.coordinates.top);
      formData.append('product[crop_w]', productsParams.coordinates.width);
      formData.append('product[crop_h]', productsParams.coordinates.height);
    }

    if(productsParams.image_params == ""){
      formData.append('product[picture]', "");
    }
    return http.put('products/' + productsParams.productId, formData)
  },

  update: (id, params) => {
    return http.put(`products/${id}`, params)
  },

  deleteProduct: productID => {
    return http.delete('products/' + productID)
  },

  saveSequence: (assembly_sequence, productId) => {
    return http.put('products/' + productId + '/sequence_product', {
      assembly_sequence: assembly_sequence,
    })
  },

  removeImage: (productId) => {
    let formData = new FormData();
    formData.append('product[picture]', "");
    formData.append('product[image]', "");
    return http.put('products/' + productId, formData)
  },

  createIgnoredProduct: (productId) => {
    return http.post('ignored_products', {
      product_id: productId,
    })
  },

  getIgnoredProducts: () => {
    return http.get('ignored_products')
  },

  deleteIgnoredProduct: (id) => {
    return http.delete('ignored_products/' + id)
  },

  createUnitProduct: (productId) => {
    return http.post('unit_products', {
      product_id: productId,
    })
  },

  getUnitProducts: () => {
    return http.get('unit_products')
  },

  deleteUnitProduct: (id) => {
    return http.delete('unit_products/' + id)
  },

  getAllProductTypes: () => {
    return http.get('product_types')
  }
}
